export default __webpack_public_path__ + "static/media/hero.c85d0e8d.png";